<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Báo cáo thiết bị thanh toán</h1>
      <div>
        <b-button
          @click="exportExcel"
          data-toggle="tooltip"
          data-placement="top"
          variant="primary"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>
          {{ showLoading ? "Đang xuất..." : "Xuất báo cáo" }}
        </b-button>
      </div>
    </div>

    <b-tabs v-model="activeTab" @input="changeTab" class="custom-tabs p-3" content-class="mt-3" style="z-index: 100" lazy>
      <b-tab title="Tổng hợp theo chi nhánh">
        <div class="pt-2" v-if="activeTab === 0">
          <TotalByBranch @params="setParams" />
        </div>
      </b-tab>
      <b-tab title="Tổng hợp theo cán bộ">
        <div class="pt-2" v-if="activeTab === 1">
          <SummaryByStaff @params="setParams" />
        </div>
      </b-tab>
      <b-tab title="Chi tiết VA">
        <div class="pt-2" v-if="activeTab === 2">
          <DetailVAReport @params="setParams" />
        </div>
      </b-tab>
      <b-tab title="Chi tiết Thiết bị">
        <div class="pt-2" v-if="activeTab === 3">
          <DeviceVAReport @params="setParams" />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TotalByBranch from './components/totalByBranch.vue'
import SummaryByStaff from './components/summaryByStaff.vue'
import DetailVAReport from './components/detailVAReport.vue'
import DeviceVAReport from './components/devicePeport.vue'
import { ReportService } from '@/services/report.service'

export default {
  name: 'PartnerPeportingTab',
  components: {
    TotalByBranch,
    SummaryByStaff,
    DetailVAReport,
    DeviceVAReport
  },
  data () {
    return {
      showLoading: false,
      activeTab: 0,
      params: {}
    }
  },

  methods: {
    showErr (message) {
      this.notiModal = true
      this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      this.msgNoti = message
    },
    // Phương thức để chuyển đổi giữa các tabs
    changeTab (tabIndex) { // AI
      this.activeTab = tabIndex // AI
    }, // AI
    setParams (params) { // AI
      this.params = params // AI
    }, // AI
    async exportExcel () { // AI
      try { // AI
        this.showLoading = true // AI
        if (this.activeTab === 0) { // AI
          await ReportService.exportReportAgent({ // AI
            export: true, // AI
            ...this.params // AI
          })
        }
        if (this.activeTab === 1) { // AI
          await ReportService.exportReportStaff({ // AI
            export: true, // AI
            ...this.params // AI
          }) // AI
        } // AI
        if (this.activeTab === 2) { // AI
          await ReportService.exportReportVa({ // AI
            export: true, // AI
            ...this.params // AI
          }) // AI
        } // AI
        if (this.activeTab === 3) { // AI
          await ReportService.exportReportDevice({ // AI
            export: true, // AI
            ...this.params // AI
          }) // AI
        } // AI
      } catch (error) { // AI
        this.showErr(error.message || 'Xuất báo cáo thất bại') // AI
      } finally { // AI
        this.showLoading = false // AI
      } // AI
    } // AI
  } // AI
}
</script>

<style scoped lang="scss">
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.custom-tabs {
  :deep(.nav-link) {
    font-family: sans-serif !important;
    font-weight: 600;
    color: #0b62ab;
  }
  :deep(.nav-link.active) {
    color: white;
    background: #0b62ab;
  }
}
</style>
